export const BASE_URL = 'https://api.sparklogistics.in';
export default BASE_URL;
